import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AgenteOutput } from "src/app/@shared/models/agente.model";
import { MapaGaragem } from "src/app/@shared/models/garagem/garagem.model";
import { BaseService } from "../../base/base.service";

const MAP_STORAGE_KEY = "MAP-GARAGEM";
const AGENTE_STORAGE_KEY = "AGENTE-GARAGEM";
const FOUR_HOURS = 4 * 60 * 60; // hour * minute * seconds

@Injectable({
  providedIn: "root",
})
export class OperacoesService extends BaseService {
  apiController = "GaragemModelo";

  get mapNameSelected() {
    return this.getMapSelected().pipe(map((response) => response?.nomeMapa));
  }
  get agenteCodIataSelected() {
    return this.getAgenteSelected().pipe(map((response) => response?.codIATA));
  }
 
  private mapSelectedSubject = new BehaviorSubject<MapaGaragem>(
    this.getMapSelectedInCookie()
  );
  private agenteSelectedSubject = new BehaviorSubject<AgenteOutput>(
    this.getAgenteSelectedInCookie()
  );

  public getAgenteSelected() {
    return this.agenteSelectedSubject.asObservable() as Observable<AgenteOutput | undefined>;
  }

  public getMapSelected() {
    return this.mapSelectedSubject.asObservable() as Observable<MapaGaragem | undefined>;
  }

  public setMapSelected(map: MapaGaragem) {
    this.setMapSelectedInCookie(map);
    this.mapSelectedSubject.next(map);
  }
  public setAgenteSelected(agente: AgenteOutput) {
    this.setAgenteSelectedInCookie(agente);
    this.agenteSelectedSubject.next(agente);
  }

  private getMapSelectedInCookie() {
    const map = getCookie(MAP_STORAGE_KEY);
    if (map) {
      try {
        return JSON.parse(map);
      } catch {
        return map;
      }
    }
  }
  private getAgenteSelectedInCookie() {
    const map = getCookie(AGENTE_STORAGE_KEY);
    if (map) {
      try {
        return JSON.parse(map);
      } catch {
        return map;
      }
    }
  }

  private setMapSelectedInCookie(map: MapaGaragem) {
    createCookie(MAP_STORAGE_KEY, JSON.stringify(map));
  }
  private setAgenteSelectedInCookie(agente: AgenteOutput) {
    createCookie(AGENTE_STORAGE_KEY, JSON.stringify(agente));
  }

}


function createCookie(name: string, value: string, maxAge?: number) {
  const maxAgeCookie = maxAge ?? FOUR_HOURS;
  document.cookie = `${name}=${value}; max-age=${maxAgeCookie};path=/`;
}

function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  else return null;
}

function deleteCookie(name: string) {
  document.cookie = `${name}=; expires=${new Date(1970, 0, 1)};path=/`;
}

export function deleteMapCookie() {
  deleteCookie(MAP_STORAGE_KEY);
}